import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'
import VueFriendlyIframe from 'vue-friendly-iframe';

import vuetify from './plugins/vuetify'
import router from './router';
import httpClient from './api/httpClient'

Vue.config.productionTip = false

Vue.use(VueFriendlyIframe);

httpClient.defaults.timeout = 40000;

httpClient.interceptors.request.use(
  config => {
    config.headers.common['Ultron-Property-Code'] = `${store.getters.GetPropertyCode()}`;
    //if (config.params !== undefined)
    //  config.params['userId'] = token.userId;
    //else
    //  config.params = { userId: token.userId };

    return config;
  },
  error => {
    if (error.response) {
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            //do something
            break;

          case 401:
          case 403:

          console.log(error, 'error timeout');
          store.commit('setTimeoutErrorMessage', 'Session timeout, Please refresh your page.');

            break;
          case 404:
            alert('page not exist');
            break;
          case 502:

        }
        return Promise.reject(error.response);
      }
    }
    return Promise.reject(error);
  }
);


new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
